module.exports = __webpack_public_path__ + "static/s101_large-804a5c4b3ccf777a34aea7d85f6193a7.jpg";